<footer class="footer no-sidebar">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 footer-copyright text-center">
                <p class="mb-0">© {{getCurrentYear()}} <a href="https://buhologistics.com" class="text-warning">Búho Logistics <img src="./../../../../assets/images/logo_bl_sm.png" class="mx-1"/></a> Inc. All rights reserved.</p>
            </div>
        </div>
    </div>
</footer>